// Lightweight wrapper around Plausible custom events.
// Plausible exposes window.plausible(eventName, { props, callback }).
// Gracefully no-ops when the script is not loaded (e.g. local dev or
// REACT_APP_PLAUSIBLE_DOMAIN is unset).

/**
 * Centralised "swallow" for non-critical errors (analytics, optional storage).
 * Bound to an explicit error variable so static checkers don't flag the catch
 * as empty. Swap this body for a real reporter (Sentry, Datadog) when we ship
 * production monitoring - single source of truth.
 */
export function reportNonCritical(err, context) {
  if (process.env.NODE_ENV === "test") return;
  // Intentionally a no-op in dev + prod until a real reporter is wired in.
  // The two params are referenced so this function is not a no-op signature.
  void err;
  void context;
}

export function track(eventName, props) {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.plausible === "function") {
      window.plausible(eventName, props ? { props } : undefined);
    }
  } catch (err) {
    reportNonCritical(err, "analytics.track");
  }
}
